<template>
	<div>
		<!-- Filters -->
		<requests-list-filters
			:options="options"
			:request-states-filter.sync="requestStatesFilter"
		/>

		<!-- Table Container Card -->
		<b-card
			no-body
			class="mb-0"
		>
			<div class="m-2">
				<!-- Table Top -->
				<b-row>
					<!-- Per Page -->
					<b-col
						cols="12"
						md="4"
						class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
					>
						<label>Mostrar</label>
						<v-select
							v-model="perPage"
							:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
							:options="perPageOptions"
							:clearable="false"
							class="per-page-selector d-inline-block mx-50"
						/>
						<label>registros</label>
					</b-col>

					<!-- Search -->
					<b-col
						cols="12"
						md="6"
						class="ml-auto"
					>
						<div class="d-flex">
							<b-form-input
								v-model="searchQuery"
								class="d-inline-block mr-1"
								placeholder="Buscar ..."
								trim
							/>
							<b-button
								v-if="$can('manage','requests') && isUser"
								:to="{ name: 'requests-create' }"
								variant="primary"
							>
								<span class="text-nowrap">Nueva Solicitud</span>
							</b-button>
						</div>
					</b-col>
				</b-row>
			</div>

			<b-table
				ref="refRequestListTable"
				class="position-relative table-requests"
				:style="totalRequests >= 1 && totalRequests <= 3 ? 'height: 280px' : 'height: inherit'"
				:items="fetchRequests"
				responsive
				:fields="tableColumns"
				primary-key="id2"
				:sort-by.sync="sortBy"
				show-empty
				empty-text="No se encontraron registros coincidentes"
				:sort-desc.sync="isSortDirDesc"
			>
				<template #table-busy>
					<div class="text-center text-primary my-2">
						<b-spinner class="align-middle mb-1"></b-spinner>
						<div>
							<b>CARGANDO</b>
						</div>
					</div>
				</template>

				<template #head(bidders_count)="data">
					<span v-html="data.label"></span>
				</template>

				<template #head(submitted_at)="data">
					<span v-html="data.label"></span>
				</template>

				<template #cell(code)="data">
					<div class="text-nowrap">{{ data.item.code }}</div>
				</template>

				<template #cell(title)="data">
					<div style="width: 700px; text-transform: uppercase;">
						<b-media vertical-align="center">
							<b-link
								v-if="$can('read','requests') && ![EN_EDICION, EN_APROBACION].includes(data.item.request_state_id)"
								:to="{ name: 'requests-view', params: { id: data.item.id } }"
								class="font-weight-bold d-block"
							>{{ data.item.title }}</b-link>
							<span
								v-else
								class="font-weight-bold d-block"
							>{{ data.item.title }}</span>
						</b-media>
					</div>
				</template>

				<template #cell(state_name)="data">
					<b-badge
						class="text-nowrap"
						:variant="`light-${data.item.state_color}`"
						pill
					>{{ data.item.state_name }}</b-badge>
				</template>

				<template #cell(submitted_at)="data">
					<span class="text-nowrap">{{ formatStringToDate(data.item.submitted_at) }}</span>
				</template>

				<template #cell(actions)="data">
					<b-dropdown
						variant="link"
						no-caret
						:right="$store.state.appConfig.isRTL"
					>
						<template #button-content>
							<feather-icon
								icon="MoreVerticalIcon"
								size="16"
								class="align-middle text-body"
							/>
						</template>

						<b-dropdown-item
							v-if="$can('read','requests') && ![EN_EDICION, EN_APROBACION].includes(data.item.request_state_id)"
							:to="{ name: 'requests-view', params: { id: data.item.id } }"
						>
							<feather-icon icon="EyeIcon" />
							<span class="align-middle ml-50">Ver</span>
						</b-dropdown-item>

						<b-dropdown-item
							v-if="$can('read','all') && [EN_EDICION, EN_APROBACION].includes(data.item.request_state_id)"
							:to="{ name: 'requests-view', params: { id: data.item.id } }"
						>
							<feather-icon icon="EyeIcon" />
							<span class="align-middle ml-50">Ver</span>
						</b-dropdown-item>

						<b-dropdown-item
							v-if="$can('manage','requests') && data.item.request_state_id === EN_EDICION && isUser"
							:to="{ name: 'requests-edit', params: { id: data.item.id } }"
						>
							<feather-icon icon="EditIcon" />
							<span class="align-middle ml-50">Editar</span>
						</b-dropdown-item>

						<b-dropdown-item
							v-if="$can('read','requests') && data.item.request_state_id === EN_APROBACION && (isLeadership || isSuperintendence)"
							:to="{ name: 'requests-edit', params: { id: data.item.id } }"
						>
							<feather-icon icon="EditIcon" />
							<span class="align-middle ml-50">Revisar</span>
						</b-dropdown-item>

						<b-dropdown-item
							v-if="(isAdmin || isSuperAdmin) && data.item.request_state_id === EN_APROBACION"
							@click="restartRequest(data.item.id)"
						>
							<feather-icon icon="RefreshCwIcon" />
							<span class="align-middle ml-50">Reiniciar Solicitud</span>
						</b-dropdown-item>

						<b-dropdown-item
							v-if="$can('manage','requests') &&  data.item.request_state_id === EN_EDICION"
							@click="deleteRequest(data.item.id)"
						>
							<feather-icon icon="TrashIcon" />
							<span class="align-middle ml-50">Eliminar</span>
						</b-dropdown-item>
					</b-dropdown>
				</template>
			</b-table>

			<div class="mx-2 mb-2">
				<b-row>
					<b-col
						cols="12"
						sm="6"
						class="d-flex align-items-center justify-content-center justify-content-sm-start"
					>
						<span
							class="text-muted"
						>Mostrando {{ dataMeta.from }} al {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
					</b-col>

					<b-col
						cols="12"
						sm="6"
						class="d-flex align-items-center justify-content-center justify-content-sm-end"
					>
						<b-pagination
							v-model="currentPage"
							:total-rows="totalRequests"
							:per-page="perPage"
							first-number
							last-number
							class="mb-0 mt-1 mt-sm-0"
							prev-class="prev-item"
							next-class="next-item"
						>
							<template #prev-text>
								<feather-icon
									icon="ChevronLeftIcon"
									size="18"
								/>
							</template>
							<template #next-text>
								<feather-icon
									icon="ChevronRightIcon"
									size="18"
								/>
							</template>
						</b-pagination>
					</b-col>
				</b-row>
			</div>
		</b-card>
	</div>
</template>

<script>
import { formatStringToDate } from "@core/utils/filter"
import { ref, onBeforeMount, onUnmounted } from "@vue/composition-api"
import { RequestStates } from "@core/utils/data"
import { getUserAccess, getUserRoles } from "@/auth/utils"
import RequestsListFilters from "./RequestsListFilters.vue"
import requestStoreModule from "../requestStoreModule"
import { avatarText } from "@core/utils/filter"
import useNotifications from "@notifications"
import useRequestsList from "./useRequestsList"
import VueSweetalert2 from "vue-sweetalert2"
import vSelect from "vue-select"
import store from "@/store"
import moment from "moment"
import axios from "@axios"
import Vue from "vue"
import "animate.css"

Vue.use(VueSweetalert2)

export default {
	components: {
		RequestsListFilters,
		vSelect
	},
	data() {
		return {
			moment
		}
	},
	setup() {
		// USE TOAST
		const { swalNotification, toastNotification } = useNotifications()
		const { EN_EDICION, EN_APROBACION } = RequestStates
		const { isUser, isLeadership, isSuperintendence, isViewer } =
			getUserAccess()
		const { isAdmin, isSuperAdmin } = getUserRoles()

		// REFS
		const options = ref({})

		const REQUEST_APP_STORE_MODULE_NAME = "app-request"

		// REGISTER MODULE
		if (!store.hasModule(REQUEST_APP_STORE_MODULE_NAME))
			store.registerModule(REQUEST_APP_STORE_MODULE_NAME, requestStoreModule)

		// UNREGISTER ON LEAVE
		onUnmounted(() => {
			if (store.hasModule(REQUEST_APP_STORE_MODULE_NAME))
				store.unregisterModule(REQUEST_APP_STORE_MODULE_NAME)
		})

		// CALL FUNCTION TO POPULATE OPTIONS FOR THE FILTERS
		onBeforeMount(() => {
			getSelectFilters()
		})

		const getSelectFilters = async () => {
			try {
				const requestStates = await axios.get("/selectors/request-states")
				options.value = { ...requestStates.data }
			} catch (error) {
				toastNotification(error.response.data.message, false)
			}
		}

		const restartRequest = (id) => {
			Vue.swal({
				title: "¿Está seguro(a) de reiniciar esta solicitud?",
				html: "<small>La solicitud volverá al estado EN EDICIÓN y se eliminarán las aprobaciones registradas.</small>",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Sí, reiniciar!",
				cancelButtonText: "Cancelar",
				customClass: {
					confirmButton: "btn btn-primary",
					cancelButton: "btn btn-outline-danger ml-1"
				},
				showClass: {
					popup: "animate__animated animate__tada"
				},
				buttonsStyling: false
			}).then((result) => {
				if (result.value) {
					store
						.dispatch("app-request/restartRequest", { id })
						.then((response) => {
							refetchData()
							swalNotification(response.data.message)
						})
						.catch((error) => {
							const message =
								error.response.data.message || "Error al reiniciar la solicitud"
							swalNotification(message, false)
						})
				}
			})
		}

		const deleteRequest = (id) => {
			Vue.swal({
				title: "¿Está seguro(a) de eliminar la solicitud?",
				html: "<small>¡Si no lo está, puede cancelar la acción!</small>",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Sí, eliminar!",
				cancelButtonText: "Cancelar",
				customClass: {
					confirmButton: "btn btn-primary",
					cancelButton: "btn btn-outline-danger ml-1"
				},
				showClass: {
					popup: "animate__animated animate__tada"
				},
				buttonsStyling: false
			}).then((result) => {
				if (result.value) {
					store
						.dispatch("app-request/deleteRequest", { id })
						.then((response) => {
							refetchData()
							swalNotification(response.data.message)
						})
						.catch((error) => {
							const message =
								error.response.data.message || "Error al eliminar la solicitud"
							swalNotification(message, false)
						})
				}
			})
		}

		const {
			fetchRequests,
			tableColumns,
			perPage,
			currentPage,
			totalRequests,
			dataMeta,
			perPageOptions,
			searchQuery,
			sortBy,
			isSortDirDesc,
			refRequestListTable,
			refetchData,

			// EXTRA FILTERS
			requestStatesFilter
		} = useRequestsList()

		return {
			fetchRequests,
			tableColumns,
			options,
			perPage,
			currentPage,
			totalRequests,
			dataMeta,
			perPageOptions,
			searchQuery,
			sortBy,
			isSortDirDesc,
			refRequestListTable,
			refetchData,
			formatStringToDate,

			// EXTRA FILTERS
			requestStatesFilter,

			// ACTIONS
			avatarText,
			deleteRequest,
			restartRequest,

			//VARIABLES
			isUser,
			isLeadership,
			isSuperintendence,
			isViewer,
			isAdmin,
			isSuperAdmin,

			EN_EDICION,
			EN_APROBACION
		}
	}
}
</script>

<style lang="scss" scoped>
.media {
	align-items: center;
}

.per-page-selector {
	width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-sweetalert.scss";
</style>